import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { IonLoading } from '@ionic/angular';

import { LoadingService } from '@core/store';

@Component({
  selector: 'co-loader',
  imports: [IonLoading],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './loader.html',
})
export class CoLoader {
  private readonly loading = inject(LoadingService);

  protected readonly isShow = this.loading.isShow;
  protected readonly message = computed(() => this.loading.text() ?? 'Loading...');
}
